import { Box, Grid, Snackbar } from "@mui/material";
import MuiAlert, { AlertColor } from '@mui/material/Alert';
import styles from './PendenciesList.module.css';
import WorkSpaceItemListFileTitle from "../WorkSpaceItem/WorkSpaceItemListFileTitle";
import { useParams } from "react-router-dom";
import { ReturnColumnSizeUserPendencies } from "../WorkSpaceItem/WorkSpaceItemListStyle/ColumnStandard";
import { useEffect, useState } from "react";
import { GetUserPendenciesAll, GetUserPendenciesByWorkspaceId } from "../../services/ValidationRuleService";
import { D4SignStatus, ItemValidationRule, WorkspacePendenci, WorkSpaceUserName } from "../../model/ItemModel";
import WorkSpaceItemListFileComponent from "../WorkSpaceItem/WorkSpaceItemListFileCompose/WorkSpaceItemListFileComponent";
import { WorkItemProps } from "../WorkSpaceItem/WorkSpaceItemListFileCompose/WorkItemProps/WorkItemProps";
import { ShareFileConfig } from "../WorkSpaceItem/PanelItens/ShareFile/ShareFileComp";
import { RenameConfig } from "../WorkSpaceItem/PanelItens/RenameComp";
import { FlowProps } from "../WorkSpaceItem/FlowFolder/WorkspaceItemFlowComponent";
import LoaderComp from "../../components/Loader/LoaderComp";
import { EmptyContainer } from "../../components/KeydriveComponents/EmptyContainer/EmptyContainer";
import { Pendencie } from "../../assets/icons/pendencie";
import { useTranslation } from "react-i18next";

export const PendenciesList = () => {
    const { nameOrg, idWorkspace } = useParams();
    const { t } = useTranslation();
    const [skip, setSkip] = useState<number>(0);
    const [limit, setLimit] = useState<number>(50);
    const [workspacePendencies, setWorkspacePendencies] = useState<WorkspacePendenci[]>([]);
    const [workspacePendenciesMax, setWorkspacePendenciMax] = useState<boolean>(false);
    const [itemIdConst, setItemIdConst] = useState<string | undefined>(undefined)
    const [nameConst, setNameConst] = useState<string | undefined>(undefined)
    const [extensionConst, setExtensionConst] = useState<string | undefined>(undefined)
    const [loading, setLoading] = useState<boolean>(false);
    const [refresh, setRefresh] = useState<boolean>(false);
    const [popupOk, setPopupOk] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>("");
    const [alertColor, setAlertColor] = useState<AlertColor>("error");

    function isBigEnough(element: any) {
        return element.filePendeci != undefined && element.filePendeci.length > 0;
    }

    useEffect(() => {
        getPreferencies();
    }, [nameOrg, idWorkspace]);

    useEffect(() => {
        if (refresh) {
            setRefresh(false);
            getPreferencies();
        }
    }, [refresh])

    useEffect(() => {
        setRefresh(true)
    }, [popupOk])

    function getPreferencies() {
        if (nameOrg) {
            setLoading(true)
            GetUserPendenciesByWorkspaceId(nameOrg, idWorkspace!, skip, limit)
                .then((newDocumentType) => {
                    newDocumentType = newDocumentType.filter(isBigEnough);
                    console.log(newDocumentType)
                    if (newDocumentType.length < limit) {
                        setWorkspacePendenciMax(false);
                    }
                    setSkip(newDocumentType.length);
                    setWorkspacePendencies(newDocumentType);

                })
                .catch((err) => console.error(err))
                .finally(() => setLoading(false));
        }
    }

    function openDetailModal(index: number, setOpen: (bool: boolean) => void) {
        setOpen(true);
    }

    function closePopUpOk() {
        setPopupOk(false);
    }

    function setPopupOkExternalError(set: boolean, message: string) {
        setAlertColor('error');
        setErrorMessage(message);
        setPopupOk(set);
    }

    function setPopupOkExternalOk(set: boolean, message: string) {
        setAlertColor('success');
        setErrorMessage(message);
        setPopupOk(set);
    }

    const handleClose = (event: any, reason: any) => {
        closePopUpOk();
    }

    const handleClosePO = (event: any) => {
        closePopUpOk();
    }

    const returnParamens = (indexPendenci: number, index: number, workSpaceC: WorkSpaceUserName, workspacePendencis: WorkspacePendenci): WorkItemProps => {
        const paramens: WorkItemProps = {
            nameOrg: nameOrg!,
            refViwer: null,
            workspaceId: workspacePendencis.workspaceId!,
            nameWorkspace: workspacePendencis.name!,
            deleteItem: (itemId: string) => { },
            setFolderExternal: (itemId: string, itemName: string | undefined) => { },
            setPopupError:setPopupOkExternalError,
            setPopupOk:setPopupOkExternalOk,
            onclickRevision: (itemId: string) => { },
            onclikMoveOpen: (itemId: string) => { },
            layoutPendencies: true,
            refresh: () => { },
            setShareFileConfig: (shareFileConfig: ShareFileConfig) => { },
            permissionType: undefined,
            isAdmin: false,
            renameUpdate: (renameConfig: RenameConfig) => { },
            boxLayout: false,
            objectReference: undefined,
            CheckboxItemList: undefined,
            handleMultiDrag: undefined,
            onClickFlow: (flowProps: FlowProps) => { },
            notificationEmail: workSpaceC.notificationEmail,
            exibirViewer: undefined,
            indexOfArray: index,
            batchRefresh: undefined,
            batchWaiter: undefined,
            updateTagName: undefined,
            workspaceItem: workSpaceC,
            updateNameDescriptionByIndex: () => { },
            updateArchivenByIndex: () => { },
            currentBatchStatus: undefined,
            isCurrentViewerItem: workSpaceC.id === itemIdConst ? true : false,
            selectedCheckbox: undefined,
            setMenuConfigConst: undefined,
            columnsSended: ReturnColumnSizeUserPendencies(),
            setIsReleaze: (isRelease: boolean, index: number) => setIsReleaze(isRelease, indexPendenci, index),
            setValidationRule: (itemValidationRule: ItemValidationRule | undefined, index: number) => setValidationRule(itemValidationRule, indexPendenci, index),
            setWorkspace: (workSpaceUserName: WorkSpaceUserName, index: number) => updateWorks(workSpaceUserName, indexPendenci, index),
            setIsD4SignSignedConst: (d4SignStatus: D4SignStatus | undefined, isD4SignSignedConst: boolean | undefined, index: number) => updateD4SignStatus(d4SignStatus, isD4SignSignedConst, indexPendenci, index),
            setIsEditingItem: () => { },
            openDetailModal: openDetailModal,
        };

        return paramens;
    };

    function setIsReleaze(isRelease: boolean, indexPendenci: number, index: number) {
        if (workspacePendencies.length > indexPendenci) {
            let array = workspacePendencies;
            if (
                array != undefined &&
                array.length > indexPendenci &&
                array[indexPendenci].filePendeci != undefined &&
                array[indexPendenci].filePendeci![index] == undefined &&
                array[indexPendenci].filePendeci!.length > index
            ) {
                array[indexPendenci]!.filePendeci![index].isRelease = isRelease;
            }
        }
    }

    function setValidationRule(itemValidationRule: ItemValidationRule | undefined, indexPendenci: number, index: number) {
        if (workspacePendencies.length > indexPendenci) {
            let array = workspacePendencies;
            if (
                array != undefined &&
                array.length > indexPendenci &&
                array[indexPendenci].filePendeci != undefined &&
                array[indexPendenci].filePendeci![index] == undefined &&
                array[indexPendenci].filePendeci!.length > index
            ) {
                array[indexPendenci]!.filePendeci![index].validationRule = itemValidationRule;
            }
        }
        console.log("setValidationRule")
    }

    function updateWorks(workSpaceUserName: WorkSpaceUserName, indexPendenci: number, index: number) {
        if (workspacePendencies.length > indexPendenci) {
            let array = workspacePendencies;
            if (
                array != undefined &&
                array.length > indexPendenci &&
                array[indexPendenci].filePendeci != undefined &&
                array[indexPendenci].filePendeci![index] == undefined &&
                array[indexPendenci].filePendeci!.length > index
            ) {
                array[indexPendenci]!.filePendeci![index] = workSpaceUserName;
            }
        }
    }

    function updateD4SignStatus(d4SignStatus: D4SignStatus | undefined, isD4SignSignedConst: boolean | undefined, indexPendenci: number, index: number) {
        if (workspacePendencies.length > indexPendenci) {
            let array = workspacePendencies;
            if (
                array != undefined &&
                array.length > indexPendenci &&
                array[indexPendenci].filePendeci != undefined &&
                array[indexPendenci].filePendeci![index] == undefined &&
                array[indexPendenci].filePendeci!.length > index
            ) {
                array[indexPendenci]!.filePendeci![index].isD4SignSigned = isD4SignSignedConst;
                array[indexPendenci]!.filePendeci![index].d4SignStatus = d4SignStatus;
            }
        }
    }

    return (
        loading ? (
            <Box mt="20px" height="100%" display="flex" justifyContent="center" alignItems="center">
                <LoaderComp big />
            </Box>
        ) :
            <>
                {(workspacePendencies.length > 0 && !loading) && <Grid container className={styles.pendenciesListContainer}>
                    <WorkSpaceItemListFileTitle
                        orderDesc={true}
                        nameOrganization={nameOrg!}
                        layoutPendencies={true}
                        columnsSended={ReturnColumnSizeUserPendencies()}
                    />
                    {workspacePendencies.map((workspacePendencis, indexPendenci) => (
                        workspacePendencis.filePendeci != undefined &&
                        workspacePendencis.filePendeci.map((workspacePendenciFile, indexOfArray) => (
                            <WorkSpaceItemListFileComponent
                                key={workspacePendenciFile.id}
                                workItemProps={returnParamens(indexPendenci, indexOfArray, workspacePendenciFile, workspacePendencis)}
                                isUpload={false}
                            />
                        ))
                    ))}
                </Grid>}
                {(workspacePendencies.length == 0 && !loading) &&
                    <Box sx={{display: "flex", flexGrow: 1}}>
                        <EmptyContainer
                            icon={<Pendencie color="#22638D" colorCircle="#22638D" />}
                            title={t("WorkspaceList.NoItens")}
                            content={t("WorkspaceList.NoItensText")} />
                    </Box>
                }
                <Snackbar
                    open={popupOk}
                    autoHideDuration={6000}
                    message="Archived"
                    onClose={handleClose}
                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                    sx={{ bottom: { xs: 50, sm: 20 } }}
                >
                    <MuiAlert elevation={6} variant="filled" sx={{ width: '100%' }} severity={alertColor} onClose={handleClosePO}>
                        {errorMessage}
                    </MuiAlert>
                </Snackbar>
            </>
    );
};
